import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  message,
} from 'antd';
import { cities, states } from "estados-cidades"
import { useEffect, useState } from 'react'

import { MinusCircleOutlined } from '@ant-design/icons';
import { ProCard } from '@ant-design/pro-components';
import { api } from '../../services/api';
import { getProfileLocal } from '../../utils/common';

const rules = {
  responsibles: [{ required: false, message: 'Digite o nome do responsável' }],
  email: [{ required: false, message: 'Digite um email válido' }],
  tel: [{ required: false, message: 'Digite um telefone' }],
}

const ResponsibleField = ({ user, form, ...props }) => {
  const [uf, setUf] = useState("RJ")
  const isStudent = getProfileLocal()?.role_id === 5


  function formattedCPF(value) {
    let formattedValue
    if (value) {
      formattedValue = value
        .replace(/\D+/g, "")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1-$2");
    }

    return formattedValue;
  }

  function formattedTell(value) {
    let formattedValue
    if (value) {
      formattedValue = value
        .replace(/\D+/g, "")
        .replace(/(\d{0})(\d)/, "$1($2")
        .replace(/(\d{2})(\d)/, "$1) $2")
        .replace(/(\d{5})(\d)/, "$1-$2");
    }

    return formattedValue;
  }

  useEffect(() => {
    const academic_responsibles = user?.academic_responsibles?.map(
      (responsible) => {
        return {
          ...user,
          academic_responsibles_cep: responsible?.cep,
          academic_responsibles_complement: responsible?.complement,
          academic_responsibles_mobile: responsible?.mobile,
          academic_responsibles_city: responsible?.city,
          academic_responsibles_neighborhood: responsible?.neighborhood,
          academic_responsibles_number: responsible?.number,
          academic_responsibles_phone: responsible?.phone,
          academic_responsibles_rg: responsible?.rg,
          academic_responsibles_state: responsible?.state,
          academic_responsibles_street: responsible?.street,
          academic_responsibles_name: responsible.name,
          academic_responsibles_cpf: formattedCPF(responsible.cpf),
          academic_responsibles_email: responsible.email,
          academic_responsibles_commercial_phone: formattedTell(
            responsible.commercial_phone
          ),
        };
      }
    );

    form.setFieldsValue({
      ...user,
      financial_responsible_name: user?.financial_responsible?.name,
      financial_responsible_cpf: formattedCPF(user?.financial_responsible?.cpf),
      financial_responsible_mobile: formattedTell(
        user?.financial_responsible?.mobile
      ),
      financial_responsible_email: user?.financial_responsible?.email,

      financial_responsible_cep: user.financial_responsible?.cep,
      financial_responsible_complement: user.financial_responsible?.complement,
      financial_responsible_city: user.financial_responsible?.city,
      financial_responsible_neighborhood:
        user.financial_responsible?.neighborhood,
      financial_responsible_number: user.financial_responsible?.number,
      financial_responsible_phone: user.financial_responsible?.phone,
      financial_responsible_rg: user.financial_responsible?.rg,
      financial_responsible_state: user.financial_responsible?.state,
      financial_responsible_street: user.financial_responsible?.street,
      financial_responsible_commercial_phone: formattedTell(
        user.financial_responsible?.commercial_phone
      ),
      academic_responsibles,
    });
  }, [])

  return (

    <Row gutter={16}>
      <Col xs={24} >
        <ProCard title="Responsável financeiro">
          <Row gutter={12}>
            <Col xs={24} md={6}>
              <Form.Item
                name={"financial_responsible_cep"}
                label="CEP"
                rules={[
                  {
                    required: false,
                    message: 'Digite o CEP',
                    blank: false,
                  },
                  {
                    validator: async (_, value) => {

                      form.setFieldsValue({
                        financial_responsible_cep: value?.replace(/\D/g, "")?.replace(/\D/g, "")
                          ?.replace(/(\d{5})(\d)/, "$1-$2"),
                      })

                      if (value?.replace(/\D/g, "")?.replace(/(\d{5})(\d)/, "$1-$2")?.length >= 8) {

                        const { data } = await api.get(`/api/misc/cep/${value?.replaceAll("-", "")?.replaceAll(".", "")}`)
                        const values = form.getFieldValue('financial_responsible')
                        form.setFieldsValue({
                          ...values,
                          financial_responsible_street: data.logradouro,
                          financial_responsible_neighborhood: data.bairro,
                          financial_responsible_city: data.localidade,
                          financial_responsible_state: data.uf,
                        })
                      }

                      return Promise.resolve();

                    },
                  }

                ]}

              >
                <Input
                  placeholder="00.000.000-0"
                  minLength={9}
                  readOnly={isStudent}
                // onChange={(e) => rgIsValid(e.target.value)}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name={"financial_responsible_street"}
                label={"Logradouro"}
              >
                <Input
                  placeholder={"Rua"}
                  readOnly={isStudent}

                />
              </Form.Item>
            </Col>

            <Col span={4}>
              <Form.Item
                name={"financial_responsible_number"}
                label="Número"
              >
                <InputNumber
                  placeholder="Número"
                  readOnly={isStudent}

                />
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <Form.Item
                name={"financial_responsible_neighborhood"} label="Bairro"

              >
                <Input placeholder="Bairro"
                  readOnly={isStudent}

                />
              </Form.Item>
            </Col>

            <Col md={4}>
              <Form.Item
                name={"financial_responsible_state"}
                initialValue={'RJ'}
                label="UF"

              >
                <Select
                  className="w-100"
                  placeholder="Estado"
                  onChange={setUf}
                  disabled={isStudent}
                >
                  {states().map(state => (
                    <Select.Option key={state}>{state}</Select.Option>
                  ))
                  }
                </Select>

              </Form.Item>
            </Col>

            <Col md={8} span={8}>
              <Form.Item name="financial_responsible_city" label="Cidade" >
                <Select
                  placeholder="Cidades"
                  disabled={isStudent}
                >
                  {cities(uf)?.map((item) => (
                    <Select.Option key={item} value={item}>
                      {item}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item name="financial_responsible_complement" label="Complemento">
                <Input.TextArea rows={4} readOnly={isStudent}
                />
              </Form.Item>

            </Col>


            <Col span={24} md={6}>
              <Form.Item
                name={"financial_responsible_name"}
                label="Nome"

              >
                <Input className="text" placeholder="Nome do responsável" readOnly={isStudent}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={6}>
              <Form.Item
                name={"financial_responsible_rg"}
                label="R.G."
                rules={[
                  {
                    required: false,
                    message: 'Digite o RG do responsável',
                    blank: false,
                  },
                  {
                    validator: async (_, value) => {

                      if (value?.length >= 14) {
                        return Promise.reject(new Error('RG invalido'));
                      }


                      form.setFieldsValue({
                        financial_responsible_rg: value
                          ?.replace(/\D+/g, "")
                          ?.replace(/(\d{2})(\d)/, "$1.$2")
                          ?.replace(/(\d{3})(\d)/, "$1.$2")
                          ?.replace(/(\d{3})(\d)/, "$1-$2")
                      })


                      return Promise.resolve();

                    },
                  }

                ]}
              >
                <Input
                  placeholder="00.000.000-0"
                  maxLength={15}
                  minLength={11}
                  // onChange={(e) => rgIsValid(e.target.value)}
                  readOnly={isStudent}

                />
              </Form.Item>
            </Col>

            <Col span={24} md={6}>
              <Form.Item
                name="financial_responsible_cpf"
                label="CPF"

                rules={[
                  {
                    required: false,
                    message: 'Digite o CPF do responsável por valor',
                    blank: false,
                  },
                  {
                    validator: async (_, value) => {
                      form.setFieldsValue({
                        financial_responsible_cpf: formattedCPF(value),
                      });


                      if (value?.length >= 15) {
                        return Promise.reject(new Error('CPF invalido'));
                      }

                      return Promise.resolve();

                    },
                  }

                ]}
              >
                <Input
                  className="text"
                  placeholder='000.000.000-00'
                  minLength={10}
                  maxLength={14}
                  readOnly={isStudent}

                />
              </Form.Item>
            </Col>

            <Col span={24} md={6}>
              <Form.Item name="financial_commercial_phone" label="Telefone Comercial">
                <Input placeholder="Telefone comercial" readOnly={isStudent}
                  type="tel" maxLength={14} onChange={(e) => {

                    form.setFieldsValue({
                      commercial_phone: formattedTell(e.target.value),
                    })
                  }} />
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <Form.Item
                name="financial_responsible_email"
                label="Email"

              >
                <Input placeholder="E-mail" type="email" readOnly={isStudent}
                />
              </Form.Item>
            </Col>

            <Col span={24} md={6}>
              <Form.Item name="financial_responsible_mobile" label="Celular">
                <Input
                  className="text"
                  placeholder="(00) 00000-0000"
                  maxLength={15}
                  onChange={(e) => {
                    form.setFieldsValue({
                      financial_responsible_mobile: formattedTell(e.target.value),
                    });
                  }}
                  readOnly={isStudent}

                />
              </Form.Item>
            </Col>
            <Col span={24} md={6}>
              <Form.Item name="financial_responsible_phone" label="Telefone">
                <Input
                  className="text"
                  placeholder="(00) 00000-0000"
                  maxLength={15}
                  onChange={(e) => {
                    form.setFieldsValue({
                      financial_responsible_phone: formattedTell(e.target.value),
                    });
                  }}
                  readOnly={isStudent}

                />
              </Form.Item>
            </Col>



          </Row>
        </ProCard>

      </Col>

      <Col xs={24} >

        <div style={{ marginTop: '23px' }}>
          <Form.List

            name="academic_responsibles"
            rules={[{ required: false, message: 'Adicione pelo menos um responsável didático' }]}
            initialValue={[{ name: 'salve', rg: '', cpf: '', email: '', mobile: '', phone: '' }]}

          >
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name, ...restField }) => (
                  <>
                    <ProCard title="Responsável Didático">

                      <Row gutter={[12, 12]} style={{ position: 'relative' }} key={name}>

                        <div
                          style={{
                            position: "absolute",
                            right: 0,
                            top: '-3px',
                            zIndex: 999,
                            cursor: 'pointer'
                          }}
                          onClick={() => {
                            if (isStudent) {
                              message.error('Você não tem permissão para remover um responsável didático')
                              return
                            }
                            remove(name);
                            form.setFieldsValue({
                              academic_responsibles: form.getFieldValue('academic_responsibles')
                            })
                          }}
                        >

                          <MinusCircleOutlined style={{ color: 'red' }} />

                        </div>



                        <Col span={24} md={6}>
                          <Form.Item
                            {...restField}
                            name={[name, "academic_responsibles_cep"]}
                            label="CEP"
                            rules={[
                              {
                                required: false,
                                message: 'Digite o CEP',
                                blank: false,
                              },
                              {
                                validator: async (_, value) => {

                                  form.getFieldValue('academic_responsibles').forEach(item => {
                                    if (item?.academic_responsibles_cep) {
                                      const cep = item.academic_responsibles_cep
                                      item.academic_responsibles_cep = cep
                                        ?.replace(/\D/g, "")
                                        ?.replace(/(\d{5})(\d)/, "$1-$2")
                                    }
                                  })


                                  if (value?.length >= 9) {

                                    const { data } = await api.get(`/api/misc/cep/${value?.replaceAll("-", "")?.replaceAll(".", "")}`)
                                    const values = form.getFieldValue('academic_responsibles').map((item, index) => {



                                      if (name === index) {
                                        return {
                                          ...item,
                                          academic_responsibles_street: data.logradouro,
                                          academic_responsibles_neighborhood: data.bairro,
                                          academic_responsibles_city: data.localidade,
                                          academic_responsibles_state: data.uf,
                                        }
                                      }

                                      return item

                                    })

                                    form.setFieldsValue({
                                      academic_responsibles: values
                                    })
                                  }

                                  return Promise.resolve();

                                },
                              }

                            ]}
                          >
                            <Input
                              placeholder="00.000.000-0"
                              maxLength={11}
                              minLength={9}
                              // onChange={(e) => rgIsValid(e.target.value)}
                              readOnly={isStudent}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={24} md={12}>
                        <Form.Item
                            {...restField}
                            name={[name, "academic_responsibles_street"]}

                            label={"Logradouro"}
                          >
                            <Input
                              placeholder={"Rua"} readOnly={isStudent}

                            />
                          </Form.Item>
                        </Col>

                        <Col span={24} md={4}>
                        <Form.Item
                            {...restField}
                            name={[name, "academic_responsibles_number"]}
                            label="Número"
                          >
                            <InputNumber
                              placeholder="Número"
                            />
                          </Form.Item>
                        </Col>

                        <Col span={24} md={12}>
                        <Form.Item
                            {...restField}
                            name={[name, "academic_responsibles_neighborhood"]} label="Bairro"

                          >
                            <Input placeholder="Bairro" readOnly={isStudent}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={24} md={4}>
                        <Form.Item
                            {...restField}
                            name={[name, "academic_responsibles_state"]}
                            initialValue={'RJ'}
                            label="UF"

                          >
                            <Select
                              className="w-100"
                              placeholder="Estado"
                              onChange={setUf}
                              disabled={isStudent}

                            >
                              {states().map(state => (
                                <Select.Option key={state}>{state}</Select.Option>
                              ))
                              }
                            </Select>

                          </Form.Item>
                        </Col>

                        <Col span={24} md={8}>
                        <Form.Item
                            {...restField}
                            name={[name, "academic_responsibles_city"]} label="Cidade" >
                            <Select
                              placeholder="Cidades"
                              disabled={isStudent}
                            >
                              {cities(uf)?.map((item) => (
                                <Select.Option key={item} value={item}>
                                  {item}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col span={24}>
                          <Form.Item name="complement" label="Complemento">
                            <Input.TextArea rows={4} readOnly={isStudent}
                            />
                          </Form.Item>

                        </Col>


                        <Col span={24} md={6}>
                        <Form.Item
                            {...restField}
                            name={[name, "academic_responsibles_name"]}
                            label="Nome"

                          >
                            <Input className="text" placeholder="Nome do responsável" readOnly={isStudent}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={24} md={6}>
                        <Form.Item
                            {...restField}
                            name={[name, "academic_responsibles_rg"]}
                            label="R.G."
                            rules={[
                              {
                                required: false,
                                message: 'Digite o RG do responsável',
                                blank: false,
                              },
                              {
                                validator: async (_, value) => {

                                  if (value?.length >= 15) {
                                    return Promise.reject(new Error('RG invalido'));
                                  }

                                  form.getFieldValue('academic_responsibles').forEach(item => {
                                    if (item?.academic_responsibles_rg) {
                                      const rg = item.academic_responsibles_rg
                                      item.academic_responsibles_rg = rg
                                        ?.replace(/\D+/g, "")
                                        ?.replace(/(\d{2})(\d)/, "$1.$2")
                                        ?.replace(/(\d{3})(\d)/, "$1.$2")
                                        ?.replace(/(\d{3})(\d)/, "$1-$2");
                                    }
                                  })

                                  return Promise.resolve();

                                },
                              }

                            ]}
                          >
                            <Input
                              placeholder="00.000.000-0"
                              maxLength={15}
                              minLength={11}
                              // onChange={(e) => rgIsValid(e.target.value)}
                              readOnly={isStudent}

                            />
                          </Form.Item>
                        </Col>

                        <Col span={24} md={6}>
                        <Form.Item
                            {...restField}
                            name={[name, "academic_responsibles_cpf"]}
                            label="CPF"

                            rules={[
                              {
                                required: false,
                                message: 'Digite o CPF do responsável por valor',
                                blank: false,
                              },
                              {
                                validator: async (_, value) => {
                                  form.getFieldValue('academic_responsibles').forEach(item => {
                                    if (item?.academic_responsibles_cpf) item.academic_responsibles_cpf = formattedCPF(item.academic_responsibles_cpf)

                                  })


                                  if (value?.length >= 15) {
                                    return Promise.reject(new Error('CPF invalido'));
                                  }

                                  return Promise.resolve();

                                },
                              }

                            ]}
                          >
                            <Input className="text" placeholder="000.000.000-00" maxLength={14} readOnly={isStudent}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={24} md={6}>
                        <Form.Item
                            {...restField}
                            name={[name, "academic_responsibles_commercial_phone"]}
                            label="Telefone comercial"
                          >
                            <Input
                              className="text"
                              placeholder="(00) 00000-0000"
                              maxLength={15}
                              readOnly={isStudent}

                              onChange={(e) => {
                                form.getFieldValue('academic_responsibles')
                                  .forEach(
                                    (item, i) => {
                                      if (i === name) {
                                        item.academic_responsibles_commercial_phone = formattedTell(e.target.value)
                                      }
                                    }
                                  )
                              }}
                            />
                          </Form.Item>
                        </Col>


                        <Col span={24} md={12}>
                        <Form.Item
                            {...restField}
                            name={[name, "academic_responsibles_email"]}
                            label="Email"

                          >
                            <Input placeholder="E-mail" type="email" readOnly={isStudent}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={24} md={6}>
                        <Form.Item
                            {...restField}
                            name={[name, "academic_responsibles_mobile"]}
                            label="Celular"
                          >
                            <Input
                              className="text"
                              placeholder="(00) 00000-0000"
                              maxLength={15}
                              onChange={(e) => {
                                form.getFieldValue('academic_responsibles')
                                  .forEach(
                                    (item, i) => {
                                      if (i === name) {
                                        item.academic_responsibles_mobile = formattedTell(e.target.value)
                                      }
                                    }
                                  )
                              }}
                              readOnly={isStudent}

                            />
                          </Form.Item>
                        </Col>

                        <Col span={24} md={6}>
                        <Form.Item
                            {...restField}
                            name={[name, "academic_responsibles_phone"]}
                            label="Telefone"
                          >
                            <Input
                              className="text"
                              placeholder="(00) 00000-0000"
                              maxLength={15}
                              onChange={(e) => {
                                form.getFieldValue('academic_responsibles')
                                  .forEach(
                                    (item, i) => {
                                      if (i === name) {
                                        item.academic_responsibles_phone = formattedTell(e.target.value)
                                      }
                                    }
                                  )
                              }}
                              readOnly={isStudent}

                            />
                          </Form.Item>
                        </Col>



                      </Row>
                    </ProCard>

                  </>
                ))}
                <Form.Item>
                  <Button type="primary" onClick={() => {
                    if (isStudent) {
                      message.error('Você não tem permissão para adicionar um responsável didático')
                      return
                    }
                    add()
                  }} block>
                    Adicionar Contato
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </div>


      </Col>
    </Row>

  )
}

export default ResponsibleField
